import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD5HEBz_umMphXcDz2SmIN18cHYx1MAyVY",
  authDomain: "aktywni-stce.firebaseapp.com",
  projectId: "aktywni-stce",
  storageBucket: "aktywni-stce.appspot.com",
  messagingSenderId: "883664350154",
  appId: "1:883664350154:web:a320414cf4c5e1dd89fd33",
  measurementId: "G-KTRDSQVRCJ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
